// Tree Heirarchy graph

import React, { useEffect, useRef, useContext } from "react";
import { useResizeObserver } from "../../tools/ResizeObserver";
// Context
import GaugeContext from "../../context/gauge/gaugeContext";
import AlertContext from "../../context/alerts/alertContext";

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

// d3
import {
	select,
	tree,
	stratify,
	scaleLinear,
	max,
	min,
	interpolateHcl,
} from "d3";

import { allFeatures } from "../../context/FeaturesData";
var zoom = 1
const createNodeLookUpTable = (data) => {
	let table = {};
	for (let i in data) {
		const node_index = data[i].index;
		table[node_index] = data[i];
	}
	return table;
};

export const getNodeSize = (node) => (2 + Math.log10(node.data.size) * 3 + Math.sqrt(node.data.size) / 20)/Math.pow(zoom, .5)

export const TreeChart = ({ height }) => {
	const svgRef = useRef();
	const wrapperRef = useRef();
	const dimensions = useResizeObserver(wrapperRef);
	const gaugeContext = useContext(GaugeContext);
	const alertContext = useContext(AlertContext);
	const {
		nodes,
		enableNode,
		removeNode,
		names,
		nodesInUse,
		nodeColor,
	} = gaugeContext;

	const colorScale = scaleLinear();
	if (nodes[0].averages.hasOwnProperty(nodeColor)) {
		colorScale.domain([
			min(nodes.map((d) => d.averages[nodeColor])),
			max(nodes.map((d) => d.averages[nodeColor])),
		]);
	} else {
		colorScale.domain([
			min(nodes.map((d) => (nodeColor !== "epsilon" ? d.size : d.y))),
			max(nodes.map((d) => (nodeColor !== "epsilon" ? d.size : d.y))),
		]);
	}
	colorScale.range(["blue", "red"]).interpolate(interpolateHcl);
	const getNodeColor = (node) => {
		if (nodeColor !== "epsilon") {
			if (nodeColor !== "size") {
				if (nodes[0].averages.hasOwnProperty(nodeColor)) {
					return colorScale(node.data.averages[nodeColor]);
				} 
				else {
					if (
						node.data.users != undefined &&(
						node.data.users.includes(nodeColor) ||
						node.data.apps.includes(nodeColor))
					) {
						return "#900";
					} 
					else {
						return "#ADA9B7";
					}
				}
			} 
			else {
				return colorScale(node.data.size);
			}
		} else {
			return colorScale(node.data.y);
		}
	}
	// useEffect(() => {
	// 	const svg = select(svgRef.current).attr("height", height);
	// 	svg.selectAll(".node").remove()
	// 	renderChart(null)
	// }, []);

	useEffect(() => {
		renderChart(null)
	}, [dimensions,nodeColor]);

	const renderChart = (e) => {

		if(e != null)
		{
			zoom = e.state.scale
		}
		var filterSize = 120 / Math.pow(zoom, 1.5)
		// Return if chart wrapper has no dimension
		if (!dimensions) return;

		// Do nothing while the data loads
		if (nodes.length < 1) return;

		// Adjusting the container for cleaner visual
		select(wrapperRef.current).style("padding", `20px 20px 20px 20px`);

		// Drawing canvas- set height
		const svg = select(svgRef.current).attr("height", height);

		// We will use this scale to level our nodes
		const yScale = scaleLinear()
			.domain([0, max(nodes.map((d) => d.y))])
			.range([0, height]);

		const xScale = scaleLinear()
			.domain([0, max(nodes.map((d) => d.x))])
			.range([0, dimensions.width]);
		// .range([0, dimensions.width - 45]);

		// Initialize a tree layout scaler
		const treeLayout = tree().size([dimensions.width, height]);
		// const treeLayout = tree().size([dimensions.width - 45, height]);

		// Let d3 transform the data in to a hierarchical form
		const root = stratify()
			.id((d) => d.index)
			.parentId((d) => d.parent)(nodes);
		
		// Let d3 compute the x and y cordinates of the nodes
		treeLayout(root);

		pruneTree(root, filterSize)


		function pathGenerator(node) {
			//let parent = node_table[node.data.parent];
			var parent = node.parent
			if (parent != null){
				parent = node.parent.data
				// Cubic curve:
				//return `M${xScale(node.data.x)},${height - yScale(node.data.y)}
				//C ${xScale(parent.x)},${height - yScale(node.data.y)}
				//${xScale(parent.x)},${height - yScale(parent.y)}
				//${xScale(parent.x)},${height - yScale(parent.y)}
				//`;
			
				// Quadratic curve, starting horizonally:
				return `M${xScale(node.data.x)},${height - yScale(node.data.y)}
				Q ${xScale(node.data.x)},${height - yScale(parent.y)}
					${xScale(parent.x)},${height - yScale(parent.y)}
				`;
			
				// Piecewise linear curve, starting horizonally:
				//return `M${xScale(node.data.x)},${height - yScale(node.data.y)}
				//V ${height - yScale(parent.y)}
				//H ${xScale(parent.x)}
				//`;
			}
		};
		
		function drawPath(g){
			g.append("path").attr("class", "link")
					.style("stroke-width", function (d) {
						// Increase the weight of the link based on these break points
						if (d.data.size > 80000) {
							return 16;
						} else if (d.data.size > 70000) {
							return 11;
						} else if (d.data.size > 50000) {
							return 8;
						} else if (d.data.size > 10000) {
							return 6;
						} else {
							return 3;
						}
					})
				.call(a=>a.lower().attr("opacity",0)
				.attr("d", (node) => {if (node.parent != null) 
					return `M${xScale(node.parent.data.x)},${height - yScale(node.parent.data.y)}
							Q ${xScale(node.parent.data.x)},${height - yScale(node.parent.data.y)}
							${xScale(node.parent.data.x)},${height - yScale(node.parent.data.y)}`})
				.transition("update")
				.duration(1000)
				.attr("opacity",1)
				.attr("d", (node) => pathGenerator(node)))
				
		}

		function drawNode(g){
			g.append("circle").attr("class", (node) => {
				for (let e in nodesInUse) {
					if (nodesInUse[e].index === node.data.index) {
						return `node ${nodesInUse[e].name}`;
					} else {
						continue;
					}
				}
				return "node";
			})
			.attr("fill", getNodeColor)
			.attr("r", getNodeSize)
			.on("click", function (node, i) {
				console.log(node)
				if (
					nodesInUse.filter(
						(nodeInUse) => nodeInUse.index === node.data.index
					).length > 0
				) {
					let currentNode = nodesInUse.filter(
						(nodeInUse) => nodeInUse.index === node.data.index
					)[0];
					select(`.${currentNode.name}`).attr("class", "node").attr("r", getNodeSize);
					select(`.${currentNode.name}-text`).remove();
					removeNode(currentNode.index, currentNode.name);
				} else if (nodesInUse.length >= 4) {
					alertContext.setAlert();
					return;
				} else {
					let name = names.pop();
					enableNode({ name: name, index: node.data.index });
					select(this).classed(`${name}`, true).attr("r", node => 1.3*getNodeSize(node));
				}
			})
			.on("mouseenter", (node) => {
				svg.selectAll(".tooltip")
					.data([node])
					.join("circle")
					.attr("class", "tooltip")
					.attr("fill", (node) => colorScale(node.data.y))
					.attr("cx", xScale(node.data.x) + 60/Math.pow(zoom,.6))
					.attr("cy", height - yScale(node.data.y) + 60/Math.pow(zoom,.6))
					.attr("r", 60/Math.pow(zoom,.6))
					.text(`Index: ${node.data.index}`)

				svg.append("text")
					.attr("class", "tooltipText")
					.text(`Size: ${node.data.size}`)
					.attr("x", xScale(node.data.x) + 11/Math.pow(zoom,.6))
					.attr("y", height - yScale(node.data.y) + 50/Math.pow(zoom,.6))
					.style("font-size", 16/Math.pow(zoom,.6)+"px")

				svg.append("text")
					.attr("class", "tooltipText2")
					.text(`Epsilon: ${node.data.epsilon.toFixed(2)}`)
					.attr("x", xScale(node.data.x) + 11/Math.pow(zoom,.6))
					.attr("y", height - yScale(node.data.y) + 70/Math.pow(zoom,.6))
					.style("font-size", 16/Math.pow(zoom,.6)+"px")
			})
			.on("mouseleave", () => {
				svg.selectAll(".tooltip").remove();
				svg.selectAll(".tooltipText").remove();
				svg.selectAll(".tooltipText2").remove();
			})
			.call(a=> a.raise().attr("opacity",0)
				.attr("cx", (node) => {if(node.parent != null) return xScale(node.parent.data.x)
										else return xScale(node.data.x)})
				.attr("cy", (node) => {if(node.parent != null) return height - yScale(node.parent.data.y)
										else return yScale(node.y)})
				.transition()
				.duration(1000)
				.attr("opacity",1)
				.attr("cx", (node) => xScale(node.data.x))
				.attr("cy", (node) => height - yScale(node.data.y)))
				
		}

		// Draw paths
		svg.selectAll(".link").interrupt("exit").attr("opacity",1)
			.data(root.descendants(), d=> d.data.index)
			.join(
				enter => drawPath(enter),
				update => update.transition().duration(1000).attr("d", (node) => pathGenerator(node)),
				exit => exit.transition("exit").duration(1000).attr("opacity", 0).remove()
			)

		// Draw nodes
		svg.selectAll(".node").interrupt("exit").attr("opacity",1)
			.data(root.descendants(), d=> d.data.index)
			.join(
				enter => drawNode(enter),
				update => update.transition().duration(1000)
					.attr("opacity",1)
					.attr("fill", getNodeColor)
					.attr("cx", (node) => xScale(node.data.x))
					.attr("cy", (node) => height - yScale(node.data.y))
					.attr("r",  (node) => (2 + Math.log10(node.data.size) * 3 + Math.sqrt(node.data.size) / 20)/Math.pow(zoom, .5)),
				exit => exit.transition("exit").duration(1000).attr("opacity", 0).remove()
			)

		// TODO - When the chart re-renders/resizes, we will update/style the nodes that are selected
		svg.select(".Alpha");
		svg.select(".Beta");
		svg.select(".Gamma");
		svg.select(".Delta");

		var defs = svg.selectAll(defs).data([""]).join("defs");

		var gradient = defs
			.append("linearGradient")
			.attr("id", "svgGradient")
			.attr("x1", "0%")
			.attr("x2", "0%")
			.attr("y1", "0%")
			.attr("y2", "100%");

		gradient
			.append("stop")
			.attr("class", "start")
			.attr("offset", "0%")
			.attr("stop-color", "red")
			.attr("stop-opacity", 1);

		gradient
			.append("stop")
			.attr("class", "end")
			.attr("offset", "100%")
			.attr("stop-color", "blue")
			.attr("stop-opacity", 1);

		// if (nodeColor !== "epsilon" && nodeColor !== "size") {
		// 	svg.selectAll(".colorbar").remove();
		// } else {
		// 	svg.selectAll(".colorbar")
		// 		.data([""])
		// 		.join("rect")
		// 		.attr("class", "colorbar")
		// 		.attr("x", dimensions.width - 15)
		// 		.attr("y", 0)
		// 		.attr("width", 30)
		// 		.attr("height", height)
		// 		.attr("fill", "url(#svgGradient)");
		// }

		// Draw the node index
		// svg.selectAll(".name")
		// 	.data(root.descendants())
		// 	.join("text")
		// 	.attr("class", "name")
		// 	.text((node) => node.data.index)
		// 	.attr("x", (node) => xScale(node.data.x))
		// 	.attr("y", (node) => height - yScale(node.data.epsilon))
		// 	.attr("dx", "-1.25em")
		// 	.attr("dy", "0.32em");
		
	}

	return (
		
			<TransformWrapper maxScale={50} onZoom={renderChart}>
				<TransformComponent>
					<div ref={wrapperRef}>
						<svg ref={svgRef} style={{width:"97vw","padding-top":"10px"}}></svg>
					</div>
				</TransformComponent>
			</TransformWrapper>
		
	);
};

function pruneTree(root, pruneSize){
	root.eachAfter(node => {
			if(node.children != undefined){
				// Prune children we dont want to show
				for (let childIndex in node.children)
				{
					//if(node.id == "84849"){console.log(node.children[childIndex])}
					if((node.children[childIndex].data.size < pruneSize && (node.data.size < 25000 || node.children[childIndex].data.size < 500))
						|| (node.data.size > 25000 && node.children[childIndex].data.size < 500))
					{
						//if(node.id == "84849"){console.log(1)}
						node.children.splice(childIndex, 1)
					}
					else if(node.data.size > 30000 && node.data.size - node.children[childIndex].data.size <= 2000)
					{
						//if(node.id == "84849"){console.log(1)}
						node.children = node.children.concat(node.children[childIndex].children)
						node.children.forEach(child => child.parent = node)
						node.children.splice(childIndex, 1)
					}
				}

				// Remove single links
				if(node.children.length == 1){
					node.children = node.children[0].children
					if (node.children != undefined)
					{
						node.children.forEach(child => child.parent = node)
					}
				}


			}
		}
	)
}

export default TreeChart;
